<script>
export default {
  name: 'RobTable',
  props: {
    items: Array,
    loading: Boolean,
    error: Object,
    selectedAssetData: Object,
    confirmingDeleteId: [Number, String],
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        pageSize: 20,
        totalSize: 0,
      }),
    },
  },
  data() {
    return {
      robTableFields: [
        { key: 'mrobMass.massName', label: 'Asset' },
        { key: 'mrobStartTime', label: 'Start Time', formatter: 'formatDateToLocal' },
        { key: 'mrobEndTime', label: 'End Time', formatter: 'formatDateToLocal' },
        { key: 'mrobInitialValue', label: 'Initial Value (L)', formatter: (value) => this.formatNumber(value) },
        { key: 'mrobCreatedUserId', label: 'Created By' },
        { key: 'mrobCreatedTime', label: 'Created At', formatter: 'formatDateToLocal' },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  methods: {
    formatNumber(value) {
      if (value === null || typeof value === 'undefined') return '';
      const numberValue = Number(value);
      if (Number.isNaN(numberValue)) return value;
      return numberValue.toFixed(1);
    },
    formatDateToLocal(dateString) {
      if (!dateString) return '';
      const date = new Date(`${dateString.replace(' ', 'T')}Z`);
      const dateOptions = { day: 'numeric', month: 'long', year: 'numeric' };
      const timeOptions = {
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
      };
      const formattedDate = date.toLocaleDateString('id-ID', dateOptions);
      const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
      return `${formattedDate}, ${formattedTime}`;
    },
    handlePageChange(page) {
      this.$emit('page-changed', page);
    },
  },
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 v-if="selectedAssetData" class="mb-0">ROB Profile {{ selectedAssetData.massName }}</h5>
      <b-button v-if="canCreate('master_rob_rob')" variant="primary" @click="$emit('add-new')">Add New ROB</b-button>
    </div>

    <div v-if="loading" class="text-center py-5">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
      <p class="mt-3 text-muted">Loading ROB profiles...</p>
    </div>
    <div v-else-if="error" class="alert alert-danger d-flex align-items-center">
      <i class="ri-error-warning-line mr-2" style="font-size: 1.2rem;"></i>
      Failed to load data. Please try again.
    </div>
    <b-table v-else striped hover responsive :items="items" :fields="robTableFields" show-empty
      tbody-tr-class="rob-row-clickable"
      @row-clicked="$emit('view-details', $event)">
      <template #empty>
        <div class="text-center py-4">
          <i class="ri-file-list-3-line" style="font-size: 3rem; color: #dee2e6;"></i>
          <p class="text-muted mt-2 mb-0">No ROB profiles found.</p>
        </div>
      </template>
      <template #cell(actions)="data">
        <b-button variant="info" size="sm" class="mr-1" @click.stop="$emit('view-details', data.item)">Detail</b-button>
        <b-button v-if="canUpdate('master_rob_rob')" variant="warning" size="sm" class="mr-1"
          @click.stop="$emit('edit-rob', data.item)">Edit</b-button>
        <b-button v-if="canDelete('master_rob_rob')" size="sm"
          :variant="confirmingDeleteId === data.item.mrobId ? 'danger' : 'outline-danger'"
          @click.stop="$emit('delete-rob', data.item)" @mouseleave="$emit('update:confirmingDeleteId', null)">
          {{ confirmingDeleteId === data.item.mrobId ? 'Confirm?' : 'Delete' }}
        </b-button>
      </template>
    </b-table>

    <b-pagination
      v-if="items && items.length > 0"
      v-model="pagination.current"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalSize"
      @change="handlePageChange"
    ></b-pagination>
  </div>
</template>

<style>
.rob-row-clickable {
  cursor: pointer;
}
</style>
